// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"Spinner_spinnerWrapper__lg2pD","bouncingBall":"Spinner_bouncingBall__D8cZu","bounce":"Spinner_bounce__M8yPE"};